import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import { useAuth } from '../contexts/AuthContext';

const NotFound = () => {
  const navigate = useNavigate();
  const { isAuthenticated, userProfile, getRedirectPath } = useAuth();

  const isUnauthorized = window.location?.pathname === '/unauthorized';

  const handleGoHome = () => {
    if (isAuthenticated && userProfile) {
      navigate(getRedirectPath(userProfile));
    } else {
      navigate('/login');
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--color-background)', padding: '24px' }}>
      <div style={{ textAlign: 'center', maxWidth: '400px' }}>
        <div style={{ width: '80px', height: '80px', backgroundColor: isUnauthorized ? 'rgba(220,38,38,0.1)' : 'rgba(15,118,110,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
          <Icon name={isUnauthorized ? 'ShieldX' : 'PackageX'} size={36} color={isUnauthorized ? 'var(--color-error)' : 'var(--color-primary)'} />
        </div>
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '3rem', fontWeight: 800, color: 'var(--color-foreground)', marginBottom: '8px' }}>
          {isUnauthorized ? '403' : '404'}
        </h1>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.25rem', fontWeight: 700, color: 'var(--color-foreground)', marginBottom: '12px' }}>
          {isUnauthorized ? 'Acceso No Autorizado' : 'Página No Encontrada'}
        </h2>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.9375rem', color: 'var(--color-muted-foreground)', marginBottom: '32px', lineHeight: 1.6 }}>
          {isUnauthorized
            ? 'No tienes permisos para acceder a esta sección. Contacta al administrador si crees que esto es un error.'
            : 'La página que buscas no existe o fue movida.'}
        </p>
        <button onClick={handleGoHome} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '0.75rem 1.5rem', backgroundColor: 'var(--color-primary)', color: '#fff', border: 'none', borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-heading)', fontSize: '0.9375rem', fontWeight: 700, cursor: 'pointer', boxShadow: 'var(--shadow-md)' }}>
          <Icon name="Home" size={16} color="currentColor" />
          {isAuthenticated ? 'Ir al Dashboard' : 'Ir al Login'}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
